export interface ILoginRequest {
  email: string;
  password: string;
  rememberMe: boolean;
}
